var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.openCustomDrawer
        ? _c("CustomDrawer", {
            ref: "drawer",
            attrs: { onClose: () => _vm.updateDimensions() },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (slotProps) {
                    return _c("div", {}, [
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "card-header" }, [
                          _c("h5", [_vm._v("Выберите габариты препаратов")]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "card-body" },
                          [
                            _vm.addDimensions
                              ? [
                                  _c(
                                    "table",
                                    {
                                      staticClass:
                                        "table table-sm table-hover mt-0",
                                    },
                                    [
                                      _c(
                                        "tbody",
                                        _vm._l(
                                          _vm.missedDrugsDimensions,
                                          function (d) {
                                            return _c("tr", [
                                              _c("td", [
                                                _vm._v(_vm._s(d.title)),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                [
                                                  _c("CountryDimension", {
                                                    attrs: {
                                                      drugId: d.id,
                                                      records: d.details,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "mt-1 text-right" },
                                    [
                                      _c("LoadingButton", {
                                        attrs: {
                                          title: "Сохранить",
                                          className: "btn btn-outline-success",
                                          onClick: () => _vm.saveDimensions(),
                                          loading: _vm.btnLoading,
                                          color: _vm.$constants.SUCCESS_COLOR,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              : [
                                  _c(
                                    "table",
                                    {
                                      staticClass:
                                        "table table-sm table-hover mt-0",
                                    },
                                    [
                                      _c(
                                        "tbody",
                                        _vm._l(
                                          _vm.doubleDrugDimensions,
                                          function (r, id) {
                                            return _c("tr", [
                                              _c("td", [
                                                _vm._v(_vm._s(r.drug.title)),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                _vm._l(
                                                  r.dimensions,
                                                  function (d, i) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "border-bottom",
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "flex flex_gap_5",
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .selectedDimensions[
                                                                      id
                                                                    ],
                                                                  expression:
                                                                    "selectedDimensions[id]",
                                                                },
                                                              ],
                                                              attrs: {
                                                                type: "radio",
                                                              },
                                                              domProps: {
                                                                value: i,
                                                                checked: _vm._q(
                                                                  _vm
                                                                    .selectedDimensions[
                                                                    id
                                                                  ],
                                                                  i
                                                                ),
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$set(
                                                                      _vm.selectedDimensions,
                                                                      id,
                                                                      i
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  d.array_value
                                                                    .depth ?? 0
                                                                ) +
                                                                  "/" +
                                                                  _vm._s(
                                                                    d
                                                                      .array_value
                                                                      .width ??
                                                                      0
                                                                  ) +
                                                                  "/" +
                                                                  _vm._s(
                                                                    d
                                                                      .array_value
                                                                      .height ??
                                                                      0
                                                                  ) +
                                                                  "/" +
                                                                  _vm._s(
                                                                    d
                                                                      .array_value
                                                                      .weight ??
                                                                      0
                                                                  )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        d.array_value.comment
                                                          ? _c("p", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  d.array_value
                                                                    .comment
                                                                )
                                                              ),
                                                            ])
                                                          : _vm._e(),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                ],
                          ],
                          2
                        ),
                      ]),
                    ])
                  },
                },
              ],
              null,
              false,
              204935841
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "flex flex_gap_10" }, [
        _c("div", [
          _c("p", [
            _c("strong", [_vm._v(_vm._s(_vm.volume) + " м3")]),
            _vm._v(" - общий объем"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v(_vm._s(_vm.weight) + " кг")]),
            _vm._v(" - общий вес"),
          ]),
          _vm._v(" "),
          _vm.missedDrugsDimensions.length
            ? _c("p", [
                _c("strong", [
                  _c(
                    "span",
                    {
                      staticClass: "badge badge-danger pointer",
                      on: {
                        click: function ($event) {
                          return _vm.selectDimensions(true)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.missedDrugsDimensions.length))]
                  ),
                ]),
                _vm._v(" - препаратов без\n        данных\n      "),
              ])
            : _vm._e(),
          _vm._v(" "),
          Object.keys(_vm.doubleDrugDimensions).length
            ? _c("p", [
                _c("strong", [
                  _c(
                    "span",
                    {
                      staticClass: "badge badge-danger pointer",
                      on: {
                        click: function ($event) {
                          return _vm.selectDimensions()
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(Object.keys(_vm.doubleDrugDimensions).length)
                      ),
                    ]
                  ),
                ]),
                _vm._v("\n        - выбрать габариты\n      "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v(_vm._s(_vm.getTotalExpenses()))]),
            _vm._v(" - всего расходов!"),
          ]),
        ]),
        _vm._v(" "),
        _vm.expenses.length
          ? _c("div", [
              _c("p", [_vm._v("Расходы по поставщику:")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex flex_gap_5 flex-wrap" },
                _vm._l(_vm.expenses, function (e) {
                  return _c("div", { staticClass: "p-1 border" }, [
                    _c("label", [
                      _c("strong", [_vm._v(_vm._s(e.totalPrice))]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$AllCurrencies[e.currency_id]?.currency) +
                          " -\n            " +
                          _vm._s(
                            _vm.$platformConstants
                              .supplierDeliveryExpensesTypes[e.type]?.title
                          )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "настройки: " +
                          _vm._s(e.perUnit) +
                          " / " +
                          _vm._s(e.price) +
                          " (" +
                          _vm._s(_vm.$AllCurrencies[e.currency_id]?.currency) +
                          ")"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "по факту: " +
                          _vm._s(e.units) +
                          " => " +
                          _vm._s(e.rate) +
                          " * " +
                          _vm._s(e.price)
                      ),
                    ]),
                  ])
                }),
                0
              ),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }